angular.module('iconoglobe')
    .factory("UserLocation", function ($q, $http, $timeout, cookieStore, localStorageService) {
        var noresponse;
        var location;
        var defer = $q.defer();
        var getLocation = function () {
            console.log(navigator.geolocation);
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function (pos) {
                    $timeout.cancel(noresponse);
                    var data = { lat: pos.coords.latitude, long: pos.coords.longitude };
                    defer.resolve(data);
                }, function (err) {
                    $timeout.cancel(noresponse);
                    fallback();
                });
                noresponse = $timeout(function () {
                    fallback();
                }, 6000);
            } else {
                fallback();
            }
            return defer.promise;
        };
        var fallback = function () {
            $http.post("/data/getClientLat").then(function (res) {
                if (res.data) {
                    location = res.data;
                    defer.resolve(res.data);
                } else {
                    defer.reject();
                }
            }, function (err) {
                console.log(err);
            });
        };
        var silently = function () {
            var deferred = $q.defer();
            var userlocation = localStorageService.get("userlocation")
           
            if (userlocation) {
                userlocation = JSON.parse(userlocation);
                
                deferred.resolve(userlocation);
            }
            if (!userlocation || !userlocation.country) {
               
                $http.post('https://www.googleapis.com/geolocation/v1/geolocate?key=AIzaSyATvilOJlWTC6f7fupy44NzzfE4RA0_KrM').then(function (res) { 
                    if (res.data) {
                        $http.get('https://api.mapbox.com/geocoding/v5/mapbox.places/' + res.data.location.lng + ',' + res.data.location.lat + '.json?limit=1&types=place%2Cpostcode%2Caddress%2Ccountry%2Clocality&access_token=pk.eyJ1IjoibG91aXNwIiwiYSI6ImNpeHVvd3ZxYzAwM2szMnQ5N2Q1cjB0Z2oifQ.1aIlYGHSc1LXrvhI2GXA9w').then(function (result) { 
                            if (result.data) {
                                let countryName = '';
                                let cityName = '';
                                for (var i = 0; i < result.data.features.length; i++) {
                                    for (var j = 0; j < result.data.features[i].context.length; j++) {
                                        if (result.data.features[i].context[j].id.startsWith("country")) {
                                            countryName = result.data.features[i].context[j].text;
                                        }
                                        if (result.data.features[i].context[j].id.startsWith("place")) {
                                            cityName = result.data.features[i].context[j].text;
                                        }
                                    }
                                }
                                var loc = {
                                    lat: res.data.location.lat,
                                    long: res.data.location.lng,
                                    country: countryName,
                                    city : cityName,
                                    timeStored: (new Date()).getTime()
                                }
                               
                                localStorageService.set('userlocation', JSON.stringify(loc));
                                deferred.resolve(loc);
                            } else {
                                deferred.reject();
                            }
                        })
                        
                    } else {
                        deferred.reject();
                        console.log("else in userlocation");

                    }
                })
            }
            return deferred.promise;
        }
        var getUserCountry = function () {
            var deferred = $q.defer();
            var userlocation = localStorageService.get("userlocation")
            
            if (userlocation) {
                userlocation = JSON.parse(userlocation);
                
               $http.get('https://api.mapbox.com/geocoding/v5/mapbox.places/' + userlocation.long + ',' + userlocation.lat + '.json?limit=1&types=place%2Cpostcode%2Caddress%2Ccountry%2Clocality&access_token=pk.eyJ1IjoibG91aXNwIiwiYSI6ImNpeHVvd3ZxYzAwM2szMnQ5N2Q1cjB0Z2oifQ.1aIlYGHSc1LXrvhI2GXA9w').then(function (res) {
                    
                    if (res.data) {
                        var countryname_long = '';
                        var countryname_short = '';
                        for (var i = 0; i < res.data.features.length; i++) {
                            for (var j = 0; j < res.data.features[i].context.length; j++) {
                                if (res.data.features[i].context[j].id.startsWith("country")) {
                                    
                                    countryname_long = res.data.features[i].context[j].text;
                                    countryname_short = res.data.features[i].context[j].short_code;
                                }
                            }
                        }
                    
                        var country = {
                            long: countryname_long,
                            short: countryname_short
                        }
                        localStorageService.set('usercountry', JSON.stringify(country));
                        deferred.resolve(country);
                    } else {
                        deferred.reject();
                    }
                })
            }
            return deferred.promise;
        }

        var getUserOwnCountryData = function () {
            var deferred = $q.defer();
            var userowncountrydata = localStorageService.get("userowncountrydata")
            if (userowncountrydata) {
                userowncountrydata = JSON.parse(userowncountrydata);
               
                deferred.resolve(userowncountrydata);
            } 
            if (!userowncountrydata) {
                var username = localStorageService.get("name")
                $http.post('/api/user/owncountrydata', { email: username }).then(function (res) { 
                    if (res) {
                        localStorageService.set('userowncountrydata', JSON.stringify(res.data));
                        deferred.resolve(res.data);
                    } else {
                        deferred.reject();
                    }
                })
            }
            return deferred.promise;
        }

        return {
            getLocation: getLocation,
            silently: silently,
            getUserCountry: getUserCountry,
            getUserOwnCountryData: getUserOwnCountryData
        };
    });
